import { isTruthyComparison } from "../../pb-screen/filters/advanced.filter.comparison";
import { AdvancedFilterOperatorType, AdvancedFilterColumnType } from "../../shared/components/filter-line/filter-line.interface";
import { transformColumnNamesToProperties } from "../../static/columName.to.property.transformation";

const columnNames = [
    { title: "Display Name", field: "displayName" },
    { title: "First Name", field: "firstName" },
    { title: "Email", field: "email" }
];


export function getFilteredUsersBySearchText(users: any[],
    searchText: string): any[] {
    const matches: any[] = [];
    const columNames: string[] = transformColumnNamesToProperties(columnNames.map((x) => x.field));
    const splitSearchText: string[] = searchText.split(" ");
    const filteredSplitSearchText: string[] = splitSearchText.filter(t => t.length > 0);

    for (let user of users) {
        let matchedAllStrings: boolean = true;
        for (let text of filteredSplitSearchText) {
            let isValidFilterOperation: boolean = false;
            for (let column of columNames) {
                if (isTruthyComparison(user[column],
                    AdvancedFilterOperatorType.Contains,
                    text,
                    AdvancedFilterColumnType.Text)) {
                    isValidFilterOperation = true;
                }
            }
            if (!isValidFilterOperation) {
                matchedAllStrings = false;
                break;
            }
        }

        if (matchedAllStrings) {
            matches.push(user);
        }
    }
    return matches;
}